import _ from 'lodash'
import { constructEmptyData } from '../actions/promotionActions'
const dealBuilderSupplier = {
  isLoading: {
    detail: false,
    delete: false,
    form: false,
    list: true,
    products: true,
  },
  isModalOpen: {
    delete: false,
  },
  viewID: null,
  deleteID: null,
  list: [],
  products: [],
  details: constructEmptyData(),
  compareDetails: constructEmptyData(),
  availableProducts: [],
  sentryEvents: [],
}
const DealBuilderSupplierReducer = function (state = dealBuilderSupplier, action) {
  switch (action.type) {
    case 'TOGGLE_DEAL_BUILDER_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'TOGGLE_DELETE_BUILDER_SUBMISSION_MODAL': {
      return {
        ...state,
        isModalOpen: {
          ...state.isModalOpen,
          delete: action.value,
        },
      }
    }
    case 'SET_DEAL_BUILDER_LIST': {
      return {
        ...state,
        list: action.value,
      }
    }
    case 'SET_VIEW_DEAL_BUILDER_ID': {
      return {
        ...state,
        viewID: action.value,
      }
    }
    case 'SET_DELETE_DEAL_BUILDER_ID': {
      return {
        ...state,
        deleteID: action.value,
      }
    }

    case 'SET_DEAL_BUILDER_DETAILS': {
      return {
        ...state,
        details: action.value,
      }
    }
    case 'UPDATE_DEAL_BUILDER_DETAILS': {
      return {
        ...state,
        details: {
          ...state.details,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_DEAL_BUILDER_DETAILS_ROW_DATA': {
      if (state.isLoading.form) {
        return state
      }

      const newModifiedRows = {
        ...state.details.modifiedRows,
        [action.key]: action.value,
      }

      return {
        ...state,
        details: {
          ...state.details,
          modifiedRows: newModifiedRows,
        },
      }
    }
    case 'REPLACE_DEAL_BUILDER_AVAILABLE_PRODUCTS': {
      return {
        ...state,
        availableProducts: action.value,
      }
    }
    case 'UPDATE_DEAL_BUILDER_AVAILABLE_PRODUCTS': {
      const availableProducts = _.merge(state.availableProducts, action.value)

      return {
        ...state,
        availableProducts,
      }
    }
    case 'SET_DEAL_BUILDER_DETAIL': {
      return {
        ...state,
        details: action.value,
      }
    }
    case 'SET_DEAL_BUILDER_COMPARE_DETAILS': {
      return {
        ...state,
        compareDetails: action.value,
      }
    }

    case 'PUSH_SENTRY_EVENT': {
      return {
        ...state,
        sentryEvents: [...state.sentryEvents, action.value],
      }
    }
    default: {
      return state
    }
  }
}

export default DealBuilderSupplierReducer
